<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'dialogStore',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-shop-dialog'" :title="state.dialog.title" :width="state.dialog.width"
    :confirm-loading="state.loading.submit" :ok-text="state.dialog.submitTxt"
    :cancel-button-props="state.viewType === 'detail' ? { style: { display: 'none' } } : {}" @ok="onSubmit"
    @cancel="closeDialog" :closable="!hasCancelOrCloseButton" :maskClosable="!hasCancelOrCloseButton">
    <a-spin :spinning="state.loading.dialogUpload">
      <div class="form-content">
        <a-form ref="formRef" :model="state.ruleForm" :rules="formRules" :wrapper-col="{ style: 'flex: 1' }"
          :required-mark="state.viewType !== 'detail'">
          <a-row class="form-row" :gutter="26">
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <a-form-item label="店铺类型" name="storeTypeCode">
                <a-select v-model:value="state.ruleForm.storeTypeCode" placeholder="请选择店铺类型"
                  :disabled="state.viewType === 'detail'" allow-clear>
                  <a-select-option v-for="item in storeTypeList" :key="item.code" :value="item.code">{{ item.name
                    }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <a-form-item label="场所业态类型" name="venueTypeId">
                <a-select v-model:value="state.ruleForm.venueTypeId" placeholder="请选择场所业态类型"
                  :disabled="state.viewType === 'detail'" allow-clear @change="onVenueTypeChange">
                  <a-select-option v-for="item in venueTypeTree" :key="item.id" :value="item.id">{{ item.typeName
                    }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <a-form-item label="店铺名称" name="storeName" class="store-name-item">
                <a-textarea v-model:value="state.ruleForm.storeName" placeholder="请输入店铺名称" :maxlength="30"
                  :disabled="state.viewType === 'detail'" :show-count="state.viewType !== 'detail'" :auto-size="false"
                  rows="2" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <a-form-item label="所属行业" :name="hasVenueChildren ? 'industryId' : 'industryRemark'">
                <template v-if="!state.ruleForm.venueTypeId">
                  <a-input disabled placeholder="请先选择场所业态类型" />
                </template>
                <a-select v-else-if="hasVenueChildren" v-model:value="state.ruleForm.industryId" placeholder="请选择所属行业"
                  :disabled="state.viewType === 'detail'" allow-clear>
                  <a-select-option v-for="item in selectedVenueChildren" :key="item.id" :value="item.id">{{
                    item.typeName
                    }}</a-select-option>
                </a-select>
                <a-input v-else v-model:value="state.ruleForm.industryRemark" placeholder="请输入所属行业" :maxlength="200"
                  :disabled="state.viewType === 'detail'" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <a-form-item label="省/市/区" name="areaIds">
                <a-cascader v-model:value="state.ruleForm.areaIds" :options="areaOptions" placeholder="请选择省/市/区"
                  :disabled="state.viewType === 'detail'" allow-clear
                  :field-names="{ label: 'label', value: 'id', children: 'children' }" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <a-form-item label="店铺面积" name="buildingArea">
                <a-input v-model:value="state.ruleForm.buildingArea" placeholder="请输入店铺面积" :maxlength="20"
                  :disabled="state.viewType === 'detail'" addon-after="㎡" allow-clear class="building-area-input" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <a-form-item label="联系人" name="contactPerson">
                <a-input v-model:value="state.ruleForm.contactPerson" placeholder="请输入联系人" :maxlength="50"
                  :disabled="state.viewType === 'detail'" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <a-form-item label="联系手机号" name="contactPhone">
                <a-input v-model:value="state.ruleForm.contactPhone" placeholder="请输入联系手机号" :maxlength="20"
                  :disabled="state.viewType === 'detail'" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <a-form-item label="详细地址" name="detailAddress" class="detail-address-item">
                <a-textarea v-model:value="state.ruleForm.detailAddress" placeholder="请输入详细地址" :rows="2"
                  :maxlength="200" :disabled="state.viewType === 'detail'" allow-clear
                  :show-count="state.viewType !== 'detail'" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="">
            <div class="space-gap" style="height: 22px" />
            <div class="section-title">用户信息</div>
            <div class="space-gap" style="height: 22px" />
            <div class="space-divider" />
          </a-form-item>
          <div class="user-section">
            <div class="user-list">
              <div v-for="user in selectedUserList" :key="user.id" class="user-row">
                <a-row class="form-row" :gutter="26">
                  <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                    <div class="user-item">
                      <span v-if="state.viewType !== 'detail'" class="user-remove" @click="removeUser(user.id)">−</span>
                      <span class="user-label">用户昵称：</span>
                      <span class="user-value">{{ user.username }}</span>
                    </div>
                  </a-col>
                  <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                    <div class="user-item">
                      <span class="user-label">手机号：</span>
                      <span class="user-value">{{ user.tel }}</span>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </div>
            <div v-if="state.viewType !== 'detail'" class="user-add-row">
              <a-row class="form-row" :gutter="26">
                <a-col :span="12">
                  <ant-button class="add" type="primary" size="small" @click="openUserSelectModal">
                    <PlusOutlined />添加用户
                  </ant-button>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-form>
      </div>
    </a-spin>
  </ant-Modal>

  <DialogUsers ref="DialogUsersRef" @confirm="onConfirmAddUsers" />
</template>

<script setup lang="ts" name="dialogStore">
import { reactive, ref, nextTick, computed } from 'vue'
import { cloneDeep } from 'lodash-es'
import { PlusOutlined } from '@ant-design/icons-vue'
import { useStore } from '@/store/shop/store'
import DialogUsers from './dialogUsers.vue'

const storeStore = useStore()

const emit = defineEmits(['createUpdate'])

const formRef = ref()
const DialogUsersRef = ref()

interface SelectedUser {
  id: string
  username: string
  tel: string
}

const INIT_RULE_FORM = {
  id: undefined as number | undefined,
  userIds: [] as string[],
  storeTypeCode: undefined as string | undefined,
  venueTypeId: undefined as number | undefined,
  industryId: undefined as number | undefined,
  industryRemark: '',
  storeName: '',
  provinceId: undefined as number | undefined,
  cityId: undefined as number | undefined,
  areaId: undefined as number | undefined,
  detailAddress: '',
  areaIds: [] as number[],
  buildingArea: undefined as number | undefined,
  contactPerson: '',
  contactPhone: ''
}

const state = reactive({
  dialog: {
    visible: false,
    title: '',
    submitTxt: '',
    width: '969px'
  },
  loading: {
    dialogUpload: false,
    submit: false
  },
  ruleForm: cloneDeep(INIT_RULE_FORM),
  rules: {
    storeTypeCode: [{ required: true, message: '请选择店铺类型', trigger: 'change' }],
    venueTypeId: [{ required: true, message: '请选择场所业态类型', trigger: 'change' }],
    storeName: [{ required: true, message: '请输入店铺名称', trigger: 'blur' }],
    detailAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
    contactPhone: [{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }]
  },
  viewType: ''
})

const hasCancelOrCloseButton = computed(() => state.viewType !== 'detail' || state.dialog.submitTxt === '关闭')

const props = defineProps<{
  storeTypeList: any[]
  venueTypeTree: any[]
  areaTreeOptions: any[]
}>()

const areaOptions = computed(() => props.areaTreeOptions)
const selectedVenueChildren = computed(() => {
  if (!state.ruleForm.venueTypeId) return []
  const parent = props.venueTypeTree.find((item: any) => String(item.id) === String(state.ruleForm.venueTypeId))
  return parent?.children || []
})

// 是否有二级子项
const hasVenueChildren = computed(() => selectedVenueChildren.value.length > 0)

// 动态校验规则
const formRules = computed(() => {
  const base: any = { ...state.rules }
  base.areaIds = [{ required: true, message: '请选择省/市/区', trigger: 'change', type: 'array' }]
  return base
})

const onVenueTypeChange = () => {
  state.ruleForm.industryId = undefined
  state.ruleForm.industryRemark = ''
  formRef.value?.clearValidate(['industryId', 'industryRemark'])
}

const selectedUsersData = ref<SelectedUser[]>([])

const selectedUserList = computed(() => selectedUsersData.value)

const removeUser = (userId: string) => {
  state.ruleForm.userIds = state.ruleForm.userIds.filter((id: string) => id !== userId)
  selectedUsersData.value = selectedUsersData.value.filter((u) => u.id !== userId)
}

const openUserSelectModal = () => {
  DialogUsersRef.value.openDialog(state.ruleForm.userIds)
}

const onConfirmAddUsers = (users: SelectedUser[]) => {
  const existingIds = new Set(state.ruleForm.userIds)
  for (const u of users) {
    if (!existingIds.has(u.id)) {
      state.ruleForm.userIds.push(u.id)
      selectedUsersData.value.push(u)
    }
  }
}

const recoverUserIds = (usersArray: any[]): string[] => {
  return usersArray.map((u: any) => String(u.userId))
}

const openDialog = (type: string, row?: any) => {
  state.viewType = type

  if (type === 'edit' && row) {
    state.dialog.title = '修改店铺'
    state.dialog.submitTxt = '修改'
  } else if (type === 'detail' && row) {
    state.dialog.title = '店铺详情'
    state.dialog.submitTxt = '关闭'
  } else {
    state.dialog.title = '新增店铺'
    state.dialog.submitTxt = '确认'
  }

  state.dialog.visible = true

  nextTick(() => {
    if ((type === 'edit' || type === 'detail') && row) {
      const userIds = recoverUserIds(row.users || [])
      state.ruleForm = {
        id: row.id,
        userIds,
        storeTypeCode: row.storeTypeCode,
        venueTypeId: row.venueTypeId,
        industryId: row.industryId,
        industryRemark: row.industryRemark || '',
        storeName: row.storeName || '',
        provinceId: row.provinceId,
        cityId: row.cityId,
        areaId: row.areaId,
        detailAddress: row.detailAddress || '',
        areaIds: [row.provinceId, row.cityId, row.areaId].filter(Boolean),
        buildingArea: row.buildingArea,
        contactPerson: row.contactPerson || '',
        contactPhone: row.contactPhone || ''
      }
      selectedUsersData.value = (row.users || []).map((u: any) => ({
        id: String(u.userId),
        username: u.nickname || u.fullName,
        tel: u.tel
      }))
    } else {
      state.ruleForm = cloneDeep(INIT_RULE_FORM)
      selectedUsersData.value = []
      formRef.value?.resetFields()
    }
  })
}

const closeDialog = () => {
  state.dialog.visible = false
  state.loading.submit = false
  state.ruleForm = cloneDeep(INIT_RULE_FORM)
  selectedUsersData.value = []
  formRef.value?.resetFields()
}

const onSubmit = () => {
  if (state.viewType === 'detail') {
    closeDialog()
    return
  }
  formRef.value
    .validate()
    .then(async () => {
      state.loading.submit = true
      const param: any = cloneDeep(state.ruleForm)
      const areaIds = param.areaIds || []
      param.provinceId = areaIds[0]
      param.cityId = areaIds[1]
      param.areaId = areaIds[2]
      delete param.areaIds
      if (!hasVenueChildren.value) {
        param.industryId = undefined
      }
      try {
        if (state.viewType === 'add') {
          await storeStore.createStore(param)
        } else {
          await storeStore.updateStore(param)
        }
        state.loading.submit = false
        emit('createUpdate')
      } catch {
        state.loading.submit = false
      }
    })
    .catch(() => {
      state.loading.submit = false
    })
}

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
.form-content {
  padding: 30px 30px 22px 30px;
}

.space-gap {
  height: 16px;
}

// ===== 表单 =====
// :deep(.form-row) {
//     padding: 0 20px 0 20px;
// }

:deep(.ant-form-item-control) {
  // <a-row class="form-row" :gutter="26">可以调整col之间的间距；
  // :deep(.form-row) { padding: 0 20px 0 20px }可以调整全部的ant-form-item-label左边距离、ant-form-item-control右边距离
  // :deep(.ant-form-item-label) {} 、:deep(.ant-form-item-control) {}也可以单独调整里面的间距；
  padding-right: 30px;
}

:deep(.ant-form-item) {
  margin-bottom: 0px;
  padding-bottom: 24px;
}

:deep(.ant-form-item-label) {
  margin-left: 0px;
  margin-right: 5px;
  width: 110px;
  text-align: right;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  height: 40px;
}

:deep(.ant-form-item-label > label) {
  font-size: 14px;
  line-height: 1;
  font-weight: 400;
}

:deep(.ant-input-affix-wrapper) {
  height: 40px;
  padding: 0 11px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

:deep(.ant-input-disabled) {
  height: 40px;
  border-color: #C5C5D3;
  border-radius: 4px;
}

:deep(.ant-select-selector) {
  height: 40px !important;
  display: flex;
  align-items: center;
  border-radius: 4px;
}


// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-input-affix-wrapper:not(:hover):not(.ant-input-affix-wrapper-focused)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-select:not(.ant-select-disabled):not(.ant-select-focused) .ant-select-selector:not(:hover)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(textarea.ant-input:not(:hover):not(:focus)) {
  border-color: #C5C5D3;
}

//textarea样式====>
:deep(.ant-input-affix-wrapper:has(textarea)) {
  height: auto !important;
  min-height: 40px;
}

:deep(textarea.ant-input) {
  min-height: 98px;
  resize: vertical;
  border-radius: 4px;
  padding: 8px 26px 8px 11px;
}

:deep(.store-name-item .ant-input-textarea),
:deep(.detail-address-item .ant-input-textarea) {
  position: relative;
  display: inline-block;
  width: 100%;

  &[data-count]::after {
    content: attr(data-count);
    position: absolute;
    right: 10px;
    bottom: 5px;
    z-index: 1;
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    pointer-events: none;
    background: #fff;
    padding-left: 4px;
    line-height: 1;
  }
}

:deep(.ant-input-data-count) {
  display: none;
}

// 仅 textarea 的清除图标需要固定到第一行，普通 a-input 保持默认 flex 布局避免 x 与 count 重叠
:deep(.ant-input-textarea .ant-input-clear-icon) {
  position: absolute;
  top: 12px;
  right: 10px;
  bottom: auto;
  margin-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  line-height: 1;
}

//<====textarea样式


.space-divider {
  height: 1px;
  background: #A0B8E5;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  color: #000;
}

.user-section {
  .user-list {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }
}

.user-row {
  margin-bottom: 8px;
}

.user-add-row {
  margin-top: 4px;

  .ant-btn {
    height: 30px;
  }
}

.user-item {
  position: relative;
  display: flex;
  align-items: center;
  height: 32px;
  font-size: 14px;
  font-weight: 400;
}

.user-remove {
  position: absolute;
  left: 2px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ff4d4f;
  color: #ff4d4f;
  font-size: 14px;
  cursor: pointer;
  line-height: 1;
}

.user-label {
  width: 110px;
  margin-right: 5px;
  text-align: right;
  color: #000;
  flex-shrink: 0;
}

.user-value {
  color: rgba(0, 0, 0, 0.65);
  margin-right: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mt10 {
  margin-top: 10px;
}

.mb15 {
  margin-bottom: 15px;
}

.ml10 {
  margin-left: 10px;
}

:deep(.ant-checkbox-disabled .ant-checkbox-inner) {
  background-color: #1890ff;
  border-color: #1890ff;
}

:deep(.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #fff;
}

// 带单位（㎡）的店铺面积输入框，清除按钮恢复默认 flex 布局，避免与 addon-after 重叠
:deep(.building-area-input .ant-input-clear-icon) {
  position: static;
  top: auto;
  right: auto;
  bottom: auto;
}
</style>
